<template>
    <div class="home">
      <img v-show="bannerImg" :src="bannerImg" alt="" srcset="" style="width: 100%;cursor: pointer;" @click="onBannerClick" >
      <div class="contentWidth">
               <zt />
        <Search @updateValue="searchValue" @updateCityCode="updateCityCode"  class="home-search" :isHot="true" :isPosition="true"></Search>
        <div class="flexBetween">
          <SearchJobItem></SearchJobItem>
          <img v-if="jobItemImg" class="home-illustration" :src="jobItemImg" alt="">
          <div v-else class="home-illustration" style="background-color: #eee;"></div>
        </div>
        
        <!-- 热招职位 -->
          <title-style :title="'热招职位'"></title-style>
          <job-tabs @updateTabs="updateTabs" :datas="hotJob"></job-tabs>
          <div class="list-box flex">
            <JobList v-for="item in jobs" :key="item.id" :jobInfo="item"></JobList>
          </div>
          <prompt v-if="jobs && jobs.length < 1 " style="margin-bottom: 20px;"></prompt>
          <More></More>
       
        <!-- 热门企业 -->
          <title-style :title="'热门企业'"></title-style>
          <div class="list-box flex">
            <CompanyList v-for="item in homeCompanyList" :key="item.id" :datas="item"/>
          </div>
          <prompt v-if="homeCompanyList && homeCompanyList.length < 1 " style="margin-bottom: 20px;"></prompt>
          <More :types="2"></More>
      </div>
      <getCityByIp></getCityByIp>
    </div>
  </template>
  
  <script>
  import { AMapManager } from "vue-amap";
  import { mapActions, mapState,mapGetters } from "vuex";
  import Search from '../../components/search.vue';  //搜索样式
  import JobList from './components/jobList.vue';
  import CompanyList from './components/companyList.vue'
  import More from '../../components/moreBtn.vue'
  import SearchJobItem from '../homePage/components/searchJobItem.vue';
  import TitleStyle from './components/titleStyle.vue';
  import JobTabs from './components/jobTabs.vue'
  import getCityByIp from '../../components/getCurrentCity.vue'
  import { getSystemImage } from '@/api/common';
  import zt from './components/zt.vue';
  export default {
    components: {Search,JobList,CompanyList,More,SearchJobItem,TitleStyle,JobTabs,getCityByIp,zt},
    name: "home",
    data() {
      return {
        conditions: {
          update24h:1,   //24h 更新,默认写死为1
          pageIndex: 1, //当前页码
          pageSize: 6,
          recommended:'',
          positionType:'',
          cityCode:""
        },
        jobItemImg:"",
        bannerImg:"",
      
        loading: true,
        amapManager: new AMapManager(),
       
      };
    },
    computed: {
      ...mapState({
        screening: state => state.dictionary.screening,
        jobs: state => state.jobs.jobList, //工作列表
        hotJob: state => state.jobs.hotJob, //热招职位
        homeCompanyList: state => state.company.homeCompanyList, //公司列表
        cityCodes:state => state.jobs.cityCodeText,
      }),
      ...mapGetters(["isLogin"]),
    },
    async created() {
      await this.getJobsList();//热招职位列表
      await this.getAllJob(); //所有职位列表
      await this.getHomeCompany(); //公司列表
      await this.getBanner();   //获取首页banner图片
      await this.getJobItemImg();
      await this.getHotJob();  //热门职位
      await this.getPositionArea();
    },
    methods: {
      ...mapActions([
        "getJobs",  //职位列表
        "getInitDate",
        "getHotJob",   //热门职位--->同时用于热招职位的tab标签
        "getAllJob",   //所有职位
        "getHomeCompany", //公司列表
        "getHomeImg",     //图片-- banner，职位侧边的图片
        "getPositionArea",
       
      ]),
       // 区域选择查询职位
       updateCityCode(){
        this.conditions.cityCode = this.cityCodes;
        //this.getJobsList();
      },
      
      async getBanner(){
        const url = await getSystemImage(17);
        this.bannerImg = url;
      },

      async getJobItemImg(){
        let datas ={
          publishPlatformType:1,
          webShowPosition:2
        }
        let res = await this.getHomeImg({...datas});
        this.jobItemImg = res[0].image_url;
      },
      
      //职位tab标签切换请求数据
      updateTabs(val){
        if(val.type==1){
          this.conditions.update24h = 1;
          this.conditions.recommended='';
          this.conditions.positionKind='';
        }else{
          this.conditions.update24h = "";
          this.conditions.positionKind=val.id;
          this.conditions.recommended=1
        }
        
        this.getJobsList();
      },
     
      // 获得筛选工作列表
      async getJobsList() {
        this.loading = true;
        this.conditions.cityCode = this.cityCodes;
        await this.getJobs({...this.conditions});
        this.loading = false;
      },
     
     //关键字搜索
     async searchValue(item) {
      console.log(item,99999)
      if(item){
        this.$router.push({
          path: "/job",
          query: {...item}
        });
      }
        
      },
      onBannerClick(){
        if(!this.isLogin){
           this.$message.error('请先登录');
        }
        else window.open('/myintro');
      }
    },
    watch: {
      cityCodes:{
        handler(){
          this.getJobsList();
        }
      }
    }
  };
  </script>
  <style lang="less" scoped>
  .home {
    background: linear-gradient(360deg, #F9FBFF 0%, #DCEAFF 100%);
    padding-bottom: 30px;
    .home-search{
      margin: 30px auto 16px ;
    }
    .home-illustration{
      width:852px ;
      height: 392px;
    }


    .list-box{
      flex-wrap: wrap;
    }
    .search {
      width: 100%;
      height: 108px;
      background: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      .searchMain {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 1200px;
        height: 40px;
        background: #f5f5f5;
        .searchVal {
          display: block;
          width: 1080px;
          height: 100%;
          .el-input__inner {
            height: 100%;
            /*border: 0;*/
            border-radius: 0;
            background: none;
            font-size: 14px;
            padding-left: 50px;
          }
          .el-icon-search {
            font-size: 20px;
            padding-left: 12px;
          }
        }
        .searchBtn {
          display: block;
          border-radius: 0;
          background: #049cfd;
          height: 100%;
          border: 0;
          width: 120px;
          font-size: 14px;
        }
      }
    }

    .homeMain {
      width: 1200px;
      margin: auto;
      // 标签
      .label {
        margin: 15px auto;
        box-sizing: border-box;
        box-shadow: 0 0 8px #eee;
        padding: 0 21px;
        background: #fff;
        .labelNav {
          font-size: 14px;
          height: 56px;
          display: flex;
          align-items: center;
          // border-bottom: 1px solid #e5e5e5;
          color: #333;
          .labelSpan {
            width: 110px;
          }
          .labelMenu {
            // margin-left: 40px;
            width: 1000px;
            display: flex;
            flex-wrap: wrap;
            .is-checked {
              .el-radio__label {
                background: #049cfd;
                color: #fff;
              }
            }
            .el-radio__label {
              padding: 7px 11px;
              font-size: 14px;
              display: inline-block;
              color: #666;
              flex: 1;
              // border: 1px solid;
            }
            .el-radio__inner {
              display: none;
            }
          }
        }
        .labelNav:last-of-type {
          border: 0;
        }
      }
    }
    .content {
      display: flex;
      justify-content: space-between;
      .contentLeft {
        width: 950px;
        .recruit {
          display: flex;
          justify-content: space-between;
          height: 140px;
          background: #fff;
          box-sizing: border-box;
          box-shadow: 0 0 8px #eee;
          margin-bottom: 15px;
          padding: 21px;
          .recruitLeft {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .recruitHeader {
              display: flex;
              align-items: center;
              .recruitTag {
                display: block;
                // width: 46px;
                padding: 0 6px;
                height: 24px;
                text-align: center;
                line-height: 24px;
                background: #049cfd;
                font-size: 12px;
                color: #fff;
                margin-left: 10px;
              }
              .recruitTagRed {
                background: #ff5555;
              }
              .recruitTagRed1 {
                background: #ff0309;
                font-weight: bold;
                font-size: 14px;
                font-style: italic;
              }
            }
            .recruitSalary {
              font-size: 18px;
              color: #ff5555;
              margin: 6px 0;
            }
            .time {
              font-size: 12px;
              color: #666;
              margin-top: 12px;
            }
          }
          .recruitRight {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-end;
            .company {
              display: flex;
              .companyLeft {
                height: 46px;
                display: flex;
                justify-content: space-between;
                flex-direction: column;
                align-items: flex-end;
                .title {
                  text-align: right;
                  margin: 0;
                }
              }
              .companyRight {
                width: 46px;
                height: 46px;
                border: 1px solid #e5e5e5;
                // display: flex;
                // justify-content: center;
                // align-items: center;
                margin-left: 20px;
                img {
                  // display: block;
                  // max-width: 100%;
                  height: 100%;
                  width: 100%;
                }
              }
            }
          }
          // 左右共用的
          .title {
            font-size: 18px;
            color: #333;
            max-width: 300px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-right: 10px;
          }
          .detail {
            font-size: 14px;
            color: #666;
            display: flex;
            align-items: center;
            .detailSeparated {
              display: block;
              width: 1px;
              height: 8px;
              background: #666;
              margin: 0 20px;
            }
          }
          .collection {
            display: flex;
            align-items: center;
            font-size: 14px;
            color: #049cfd;
            .look-detail {
              display: block;
              background: #049cfd;
              color: #fff;
              text-align: center;
              height: 30px;
              line-height: 30px;
              padding: 0;
              width: 100px;
              margin-right: 20px;
            }
            p {
              cursor: pointer;
            }
            .fonticon {
              font-size: 16px;
              margin-right: 6px;
            }
            .collectionBtn {
              padding: 0;
              display: block;
              font-size: 14px;
              color: #999;
              margin-left: 20px;
            }
          }
        }
      }
      .qrCode {
        font-size: 18px;
        color: #333;
        align-content: center;
        line-height: 56px;
        display: block;
      }
      .contentRight {
        width: 230px;
        .home-login {
          // height: 266px;
          background: #fff;
          box-sizing: border-box;
          padding: 0 15px 18px;
          .loginTitle {
            font-size: 16px;
            color: #333;
            text-align: center;
            line-height: 56px;
          }
  
          .loginParameter {
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border: 1px solid #e5e5e5;
            box-sizing: border-box;
            padding: 0 10px;
            font-size: 12px;
            color: #333;
            margin-top: 10px;
            .el-input {
              width: 130px;
              height: 100%;
              display: flex;
              justify-content: space-between;
              align-items: center;
            }
            .el-input__inner {
              border: 0;
              padding: 0;
              height: 100%;
              border-radius: 0;
            }
            .el-input-group__append {
              background: none;
              border: 0;
              padding: 0;
              width: 70px;
              img {
                display: block;
                height: 20px;
              }
            }
          }
          .loginParameter:first-of-type {
            margin-top: 0;
          }
          .loginBtn {
            border-radius: 0;
            background: #049cfd;
            display: block;
            width: 100%;
            height: 30px;
            line-height: 30px;
            font-size: 16px;
            color: #fff;
            padding: 0;
            border: 0;
            margin: 20px 0;
          }
          .loginFooter {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            color: #999;
            .goRegister {
              color: #049cfd;
            }
          }
        }
        .information {
          background: #fff;
          box-sizing: border-box;
          .informationMain {
            // height: 266px;
            box-sizing: border-box;
            padding: 30px 0;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #f5f5f5;
            .point {
              display: block;
              width: 80px;
              height: 80px;
              border-radius: 50%;
              margin-bottom: 5px;
            }
            .name {
              font-size: 18px;
              color: #333;
            }
            .delivery-today {
              font-size: 12px;
              color: #999;
              margin-top: 10px;
              span {
                color: #049cfd;
              }
            }
            .amount {
              display: flex;
              justify-content: center;
              align-items: center;
              margin-top: 20px;
              .amountMenu {
                font-size: 14px;
                color: #666;
                text-align: center;
                .amountMenuNumber {
                  font-size: 14px;
                  color: #049cfd;
                  margin-bottom: 14px;
                  .number {
                    font-size: 24px;
                    margin-right: 10px;
                  }
                }
              }
              .amountMenu:last-of-type {
                margin-left: 30px;
              }
            }
          }
          .degree {
            height: 80px;
            box-sizing: border-box;
            padding: 17px 15px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            font-size: 14px;
            color: #333;
          }
        }
        .advertising {
          display: block;
          width: 100%;
          height: 206px;
          margin: 10px 0;
          cursor: pointer;
        }
      }
    }
    .el-dialog__body {
      padding: 10px 0 47px;
    }
    &-dialog {
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 18px;
      color: #333;
      &-icon {
        width: 40px;
        height: 40px;
        font-size: 42px;
        text-align: center;
        line-height: 40px;
        margin-bottom: 10px;
      }
      &-success {
        color: #049cfd;
      }
      &-warning {
        color: #ff5555;
        font-size: 38px;
      }
      &-question {
        color: #049cfd;
      }
      &-lookbtns {
        width: 80px;
        height: 30px;
        background: #049cfd;
        font-size: 14px;
        color: #fff;
        border: 0;
        line-height: 30px;
        margin-top: 40px;
        padding: 0;
        display: block;
        text-align: center;
      }
    }
    .captcha-wraper {
      position: relative;
     
    }
    .specil-performance {
      padding: 4px 7px;
      // border-radius: 5px;
      background: #049cfd;
      color: #ffffff;
      font-size: 12px;
      margin-left: 5px;
    }
  }
  </style>
  